import { Pipe, PipeTransform } from '@angular/core';
import { ValueType } from '@deprecated/api-interfaces';
import { Observable, from } from 'rxjs';
import { DataConversionService } from '../services';

@Pipe({
  name: 'spxDataConversionLabel',
})
export class SpxDataConversionLabelPipe implements PipeTransform {
  constructor(private dataConversionService: DataConversionService) {}
  transform(label: string, valueType: ValueType): Observable<string> {
    return from(
      this.dataConversionService.convertLabel(label, {
        sourceUnit: label,
        valueType: valueType,
      }),
    );
  }
}
